var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2316 19.424C12.3516 19.6016 12.5121 19.7469 12.6994 19.8472C12.8866 19.9476 13.095 20 13.3066 20C13.5182 20 13.7265 19.9476 13.9138 19.8472C14.1011 19.7469 14.2616 19.6016 14.3816 19.424L26.1517 2.09185C26.288 1.89194 26.3679 1.65779 26.3827 1.41484C26.3976 1.17189 26.3469 0.929429 26.2361 0.713805C26.1253 0.498181 25.9586 0.317638 25.7542 0.191793C25.5498 0.0659484 25.3155 -0.000386152 25.0767 -2.69133e-06L1.53644 1.42458e-06C1.29822 0.00100461 1.06477 0.0681923 0.861203 0.194339C0.657636 0.320485 0.49165 0.500818 0.381097 0.715943C0.270544 0.931068 0.219606 1.17285 0.233761 1.41528C0.247917 1.65771 0.32663 1.89162 0.461436 2.09186L12.2316 19.424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDownArrow);
export default __webpack_public_path__ + "static/media/white-down-arrow.0aed893ad1e10e6361792242492ba54e.svg";
export { ForwardRef as ReactComponent };